import { useState } from 'react';
import { ExerciseSpecificClient, ExerciseSpecificDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useExerciseSpecificApi = () => {
    const apiClient = new ExerciseSpecificClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ExerciseSpecificDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createExerciseSpecific(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ExerciseSpecific');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ExerciseSpecificDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateExerciseSpecific(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ExerciseSpecific');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getExerciseSpecificById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ExerciseSpecific');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchExerciseSpecifics(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ExerciseSpecifics');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteExerciseSpecific(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ExerciseSpecific');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};